import { DownloadButton, useAuth } from "@airborne/react-admin";
import { CircularProgress, Grid, TextField as MUITextField } from "@material-ui/core";
import { Add, ThumbDown, ThumbDownAlt, ThumbUp } from "@material-ui/icons";
import keyBy from "lodash/keyBy";
import * as React from "react";
import { useState } from "react";
import { Button, Confirm, Datagrid, FunctionField, ListContextProvider, TextField, useNotify } from "react-admin";
import { useHistory } from "react-router-dom";
import CreatedByField from "../../../../../src/Components/ReferenceFields/CreatedBy/CreatedByField";
import { SectionTitle } from "../../../../../src/Components/SectionTitle";
import { UploadFile } from "../../../../../src/Components/UploadFile";
import { PbhRequestOrderTabEnum } from "../../../../../src/Enums/PbhRequestOrderTabEnum";
import { PbhRequestStatus } from "../../../../../src/Enums/PbhRequestStatus";
import { useAppDataProvider } from "../../../../../src/dataprovider";
import { CustomDateField } from "../../../../Components/CustomDateField";
import { PbhRequestAlternatePnPutModel } from "../../Models/PbhRequestAlternatePnModel";

const unChangeableStatus = [PbhRequestStatus.Accomplished, PbhRequestStatus.Rejected, PbhRequestStatus.Cancelled];

const PbhAlternatePnView = props => {
  const [loading, setLoading] = useState(false);
  const [isRejectDialogOpen, setIsRejectDialogOpen] = useState(false);
  const [isRejectAllDialogOpen, setIsRejectAllDialogOpen] = useState(false);
  const [remark, setRemark] = React.useState("");
  const [remarkValidation, setRemarkValidation] = React.useState(false);
  const [rejectProps, setRejectProps] = React.useState<any>(null);

  const dataProvider = useAppDataProvider();
  const notify = useNotify();
  const history = useHistory();
  const { user } = useAuth();
  const requestId = props.requestId;

  const isRejectButtonShown = status => {
    if (
      (status === PbhRequestStatus.AlternatePnOffered || status === PbhRequestStatus.Reserved) &&
      props?.requestAlternatePn?.some(data => data.status === PbhRequestStatus.AlternatePnOffered)
    )
      return false;
    return true;
  };
  const RejectAllButtonClick = props => {
    if (!remark) {
      setRemarkValidation(true);
      return;
    }
    let requestAlternatePutModel: PbhRequestAlternatePnPutModel = new PbhRequestAlternatePnPutModel();
    requestAlternatePutModel.id = props.requestAlternatePn?.[0]?.id;
    requestAlternatePutModel.AlternatePn = props.requestAlternatePn?.[0]?.alternatePn;
    requestAlternatePutModel.RequestId = props.requestAlternatePn?.[0]?.requestId;
    requestAlternatePutModel.Status = PbhRequestStatus.AlternatePnRejected;
    requestAlternatePutModel.UpdatedBy = user?.employeeId;
    requestAlternatePutModel.UpdatedDate = new Date();
    requestAlternatePutModel.Note = remark;
    dataProvider
      .postRejectAllPbhRequestAlternatePn(requestAlternatePutModel)
      .then(result => {
        props.finalCallBack();
        notify(`Record Updated`, "success", false, true);
        history.push("/pbhrequestorders/" + requestId + "/3");
        handleRejectDialogClose();
      })
      .catch(result => {
        notify(`${result}`, "error", false, true);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const updatePbhRequestOrder = model => {
    dataProvider
      .putPbhRequestAlternatePn(model)
      .then(result => {
        props.finalCallBack();
        notify(`Record Updated`, "success", false, true);
        history.push("/pbhrequestorders/" + requestId + `/${PbhRequestOrderTabEnum.AltenatePn}`);
        handleRejectDialogClose();
      })
      .catch(error => notify(`${error}`, "error", false, true))
      .finally(() => setLoading(false));
  };
  const offerAnotherPn = e => {
    props?.offerAnotherPnClick?.(true);
  };
  const AcceptButtonClick = props => e => {
    let pbhRequestAlternatePutModel: PbhRequestAlternatePnPutModel = new PbhRequestAlternatePnPutModel();
    pbhRequestAlternatePutModel.id = props.record.id;
    pbhRequestAlternatePutModel.AlternatePn = props.record.alternatePn;
    pbhRequestAlternatePutModel.RequestId = props.record.requestId;
    pbhRequestAlternatePutModel.Status = PbhRequestStatus.AlternatePnAccepted;
    pbhRequestAlternatePutModel.UpdatedBy = user?.employeeId;
    pbhRequestAlternatePutModel.UpdatedDate = new Date();
    updatePbhRequestOrder(pbhRequestAlternatePutModel);
  };
  const RejectButtonClick = (props = rejectProps) => {
    if (!remark) {
      setRemarkValidation(true);
      return;
    }
    let pbhRequestAlternatePutModel: PbhRequestAlternatePnPutModel = new PbhRequestAlternatePnPutModel();
    pbhRequestAlternatePutModel.id = props.record.id;
    pbhRequestAlternatePutModel.AlternatePn = props.record.alternatePn;
    pbhRequestAlternatePutModel.RequestId = props.record.requestId;
    pbhRequestAlternatePutModel.Status = PbhRequestStatus.AlternatePnRejected;
    pbhRequestAlternatePutModel.UpdatedBy = user?.employeeId;
    pbhRequestAlternatePutModel.UpdatedDate = new Date();
    pbhRequestAlternatePutModel.Note = remark;
    updatePbhRequestOrder(pbhRequestAlternatePutModel);
  };
  const handleRejectDialogClose = () => {
    setIsRejectDialogOpen(false);
    setIsRejectAllDialogOpen(false);
    setRemark("");
    setRemarkValidation(false);
  };
  const handleRejectDialogOpen = (props, isAll) => e => {
    if (isAll) {
      setIsRejectAllDialogOpen(true);
    } else {
      setIsRejectDialogOpen(true);
    }
    setRemark("");
    setRemarkValidation(false);
    setRejectProps(props);
  };
  const handleChangeRemark = e => setRemark(e.target.value);
  const AlternatePnAcceptButton = props => {
    return props.record.status === PbhRequestStatus.AlternatePnOffered ? (
      <Button
        disabled={props?.requestDetail?.requestStatus === PbhRequestStatus.Cancelled}
        size="small"
        variant="contained"
        style={{ backgroundColor: "green" }}
        onClick={AcceptButtonClick(props)}
      >
        {loading ? <CircularProgress size="1rem" color="secondary" /> : <ThumbUp />}
      </Button>
    ) : null;
  };
  const AlternatePnRejectButton = props => {
    return props?.record?.status === PbhRequestStatus.AlternatePnOffered ? (
      <Button
        disabled={props?.requestDetail?.requestStatus === PbhRequestStatus.Cancelled}
        size="small"
        variant="contained"
        style={{ backgroundColor: "red" }}
        onClick={handleRejectDialogOpen(props, false)}
      >
        {loading ? <CircularProgress size="1rem" color="secondary" /> : <ThumbDown />}
      </Button>
    ) : null;
  };
  const UploadFileAction = props => {
    return (
      <UploadFile
        label=""
        multiple={false}
        placeholder={"Upload"}
        onHandleFileExecute={props?.finalCallBack}
        source="pbhalternatepnrelations"
        object={{ pbhAlternatePnId: props?.record?.id }}
      />
    );
  };

  return (
    <>
      <Confirm
        isOpen={isRejectDialogOpen || isRejectAllDialogOpen}
        title={`Are you sure you want to reject?`}
        content={
          <MUITextField
            label="Remark"
            error={remarkValidation}
            required
            value={remark}
            multiline
            fullWidth
            maxRows={4}
            variant="outlined"
            onChange={handleChangeRemark}
          />
        }
        onConfirm={() => {
          isRejectAllDialogOpen ? RejectAllButtonClick(rejectProps) : RejectButtonClick(rejectProps);
        }}
        onClose={handleRejectDialogClose}
      />
      <Grid container direction="row" spacing={1} justify="space-around" alignItems="center">
        <SectionTitle label="Alternate Pn Info" />
      </Grid>
      <Grid container style={{ width: "100%", overflow: "auto", marginBottom: 5 }}>
        <Grid item xs={12} sm={12}>
          <ListContextProvider
            value={{
              data: keyBy(props.requestAlternatePn, "id"),
              ids: props.requestAlternatePn?.map?.(({ id }) => id),
              currentSort: { field: "id", order: "ASC" },
            }}
          >
            <Datagrid>
              {user?.isCustomer && props?.readonly === false && (
                <AlternatePnAcceptButton
                  label="Accept"
                  orderData={props.requestDetail}
                  alternatePns={props.requestAlternatePn}
                  finalCallBack={props.finalCallBack}
                />
              )}

              {user?.isCustomer && props?.readonly === false && (
                <AlternatePnRejectButton
                  label="Reject"
                  orderData={props.requestDetail}
                  alternatePns={props.requestAlternatePn}
                  finalCallBack={props.finalCallBack}
                />
              )}

              {props?.readonly === false && (
                <UploadFileAction label="File Upload" finalCallBack={props.finalCallBack} />
              )}

              <FunctionField
                style={{ fontSize: 12 }}
                label="Files"
                render={(record: any) => {
                  return record?.files?.map?.(file => (
                    <DownloadButton target={`download/${file.objectKey}`} buttonText={file.name} variant="text" />
                  ));
                }}
              />

              <TextField label="Alternative PNs" source="alternatePn" />
              <FunctionField
                style={{ fontSize: 12 }}
                label="Status"
                render={(record: any) =>
                  record.status === Number(PbhRequestStatus.AlternatePnOffered)
                    ? "Alternate Pn Offered"
                    : record.status === Number(PbhRequestStatus.AlternatePnAccepted)
                      ? "Alternate Pn Accepted"
                      : record.status === Number(PbhRequestStatus.AlternatePnRejected)
                        ? "Alternate Pn Rejected"
                        : "Alternate Pn None"
                }
              />
              <TextField label="Remark" source="note" />
              <CreatedByField label="Offered By" link={false} />
              <CustomDateField source="createdDate" locales="en-GB" label="Offered  Date" showTime />
              <CreatedByField source="updatedBy" label="Approved/Rejected By" link={false} />
              <CustomDateField source="updatedDate" label="Approved/Rejected Date" locales="en-GB" showTime />
            </Datagrid>
          </ListContextProvider>
        </Grid>
      </Grid>
      {/* Reject Button */}
      <Grid style={{ display: "flex", justifyContent: "end" }}>
        {(props.requestDetail?.requestStatus === PbhRequestStatus.AlternatePnOffered ||
          props.requestDetail?.requestStatus === PbhRequestStatus.Reserved) &&
          user?.isCustomer &&
          props?.requestDetail?.requestStatus !== PbhRequestStatus.Cancelled && (
            <Button
              label={loading ? "Rejected!" : "Reject All Alternate Pn"}
              disabled={isRejectButtonShown(props.requestDetail?.requestStatus) || props?.readonly}
              size="medium"
              variant="contained"
              color="primary"
              onClick={handleRejectDialogOpen(props, true)}
              style={{ margin: "8px" }}
            >
              {loading ? <CircularProgress size="2rem" color="secondary" /> : <ThumbDownAlt />}
            </Button>
          )}
        {props.requestDetail?.requestStatus !== PbhRequestStatus.AlternatePnAccepted &&
          !user?.isCustomer &&
          props?.requestDetail?.requestStatus !== PbhRequestStatus.Cancelled && (
            <>
              <Button
                label={"Offer another pn"}
                size="medium"
                variant="contained"
                disabled={loading || props?.readonly}
                onClick={offerAnotherPn}
                style={{ margin: "8px", background: "#ffc107" }}
              >
                {loading ? <CircularProgress size="2rem" color="secondary" /> : <Add />}
              </Button>
            </>
          )}
      </Grid>
    </>
  );
};

export default PbhAlternatePnView;
